module.exports = __webpack_public_path__ + "static/media/thirteenth_columbus_regional_hospital.0c2e3806.mp4";